module.exports = {"loadingText":"Načítavam konfiguračné údaje pre modul Report"}